import { TableProps } from 'antd';
import React, { FC, ReactNode, useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { TemplateInsightBaseTable } from '../template-insight-base-table';
import { ShowAllTable } from './show-all-table';

interface Props<T = any> extends TableProps<T> {
  className?: string;
  titleLabel: string;
  isLoading: boolean;
  renderEmpty: () => ReactNode;
}

// TODO: update to AG Grid

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledButton = styled(Button)`
  background: var(--white-100);
  justify-content: center;
`;

const getRowsPerTable = () => {
  const headerHeight =
    document.querySelector('#page_header')?.clientHeight ?? 120;
  const actionRowHeight = 48;
  const subTabsHeight = 32 + 16 + 16;
  const totalStaticHeight = headerHeight + actionRowHeight + subTabsHeight;

  const tableTitle = 40;
  const tableGap = 32;
  const tableRowHeight = 47;
  const tableHeaderHeight = 53;
  const viewAll = 40;
  const NUMBER_OF_TABLE = 3;

  const windowHeight = window.innerHeight;
  const totalUseableHeight =
    windowHeight -
    (totalStaticHeight +
      NUMBER_OF_TABLE * (tableGap + tableHeaderHeight + viewAll + tableTitle));
  const totalNumberOfRow = totalUseableHeight / tableRowHeight;
  const rowsPerTable = totalNumberOfRow / NUMBER_OF_TABLE;

  const minimumRows = 2;

  return Math.max(minimumRows, rowsPerTable);
};

export const ShowMoreTable: FC<Props> = ({
  className,
  dataSource,
  titleLabel,
  isLoading,
  ...tableProps
}) => {
  const [rows, setRow] = useState(4);
  const rowLength = dataSource?.length;

  useEffect(() => {
    const fitTableToPage = () => {
      setRow(getRowsPerTable());
    };

    window.addEventListener('resize', fitTableToPage);
    if (rowLength) {
      requestAnimationFrame(fitTableToPage);
    }

    return () => window.removeEventListener('resize', fitTableToPage);
  }, [rowLength]);

  const data = useMemo(() => dataSource?.slice(0, rows), [dataSource, rows]);
  const [showMore, setShowMore] = useState(false);

  // TODO: table should support table title
  return (
    <Wrapper>
      <TemplateInsightBaseTable
        {...tableProps}
        dataSource={data}
        titleLabel={titleLabel}
        isLoading={isLoading}
      />
      {(dataSource?.length ?? 0) > rows && (
        <StyledButton type="link" onClick={() => setShowMore(true)}>
          <FormattedMessage id="view_all" />
        </StyledButton>
      )}
      <ShowAllTable
        {...tableProps}
        dataSource={dataSource}
        visible={showMore}
        onCancel={() => {
          setShowMore(false);
        }}
        titleLabel={titleLabel}
      />
    </Wrapper>
  );
};
